import Typography from "@material-ui/core/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";
import Hidden from "@material-ui/core/Hidden";
import { colors } from "../../theme";
import LogoYfca from "./svg/logo-yfca.svg";
import LogoActadapt from "./svg/logo-actadapt.png";
import LogoGca from "./svg/logo-gca.svg";
import DefaultBackground from "./svg/register-background.svg";

const useStyles = makeStyles((theme) => ({
  imgContainer: {
    position: "absolute",
    width: "calc(100% - 275px)",
    bottom: "0",
    [theme.breakpoints.down("sm")]: {
      width: "95%",
      marginLeft: "1%"
    },
  },
  sideImage: {
    backgroundImage: `url(${DefaultBackground})`,
    position: "absolute",
    height: "100%",
    width: "250px",
    left: 0,
  },
  gridImage: {
    margin: "0 auto",
  },
  signin: {
    textAlign: "center",
    marginTop: "25px"
  },
  link:  {
    color:colors.LINK,
    marginTop: "20px",
  },
  container: {
    padding: "20px",
  }
}));

export default function Thanks() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid className={classes.container} container sm xs={12} spacing={2}>
        <Hidden smDown>
          <Grid item md={2}>
            <Grid container item className={classes.sideImage} />
          </Grid>
        </Hidden>
        <Grid item xs={12} sm={12} md={8} container justify="center" alignItems="center">
          <Typography component="p">{t("forgotpassword.confirmation")}</Typography>
          <Link className={classes.link} component={RouterLink} to="/signin" variant="body2">
                {t("forgotpassword.signin")} 
              </Link>
          <Grid className={classes.imgContainer} container sm xs={12} spacing={2}>
            <Grid container item xs={12} sm={4}>
              <img src={LogoYfca} style={{width: "80px"}} className={classes.gridImage} alt="logo"/>
            </Grid>
            <Grid container item xs={12} sm={4} >
              <img src={LogoGca} className={classes.gridImage} alt="logo"/>
            </Grid>
            <Grid container item xs={12} sm={4}>
              <img src={LogoActadapt} style={{width: "auto", height: "60px"}} className={classes.gridImage} alt="logo"/>
            </Grid>
          </Grid>
        </Grid>
    </Grid>
  );
}
